import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import NavigatorMain from '../NavigatorMain';
import { Toast } from 'antd-mobile/lib';
import Util from '../../util.js';

const questionsArr = [
  {
    title: '此基金产品是高风险产品，您是否确定已经了解其风险？',
    selections: [
      '是',
      '否'
    ]
  },
  {
    title: '此基金产品是高风险产品，可能因市场波动导致本金损失，您是否已充分考虑该投资风险？',
    selections: [
      '是',
      '否'
    ]
  }
];
class HighestRiskPoint extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
    this.answers = [];
    this.goCallback=false;
  }
  componentWillMount(){
    document.title = '特高风险提示'
  }
  makeAnswers(key, answer){
    this.answers[key] = answer;
  }

  addQuestions(queArr){
    return queArr.map((item, index, array)=>{
      return <Question key = {index} index = {index} makeAnswers = {(key, answer)=>{this.makeAnswers(key, answer);}} question = {item}/>
    });
  }

  goOn(){
    let length = 0;
    this.answers.forEach((item, index, array)=>{length++});
    if(length != questionsArr.length){
      Toast.info('请回答上述全部问题！', Util.ToastTime );
      return ;
    }
    if(this.answers.some((item, index, array)=>item)){
      Toast.info('请充分了解和考虑该产品的投资风险之后，再进行购买！', Util.ToastTime );
      return ;
    }
    this.goCallback=true;
    hashHistory.go(-1);
   
  }
  componentWillUnmount(){
    if (this.goCallback) {
       this.props.location.state.callback ? this.props.location.state.callback() : null
    }
  }
  render(){
    let _this=this;
    console.log(this.props.location)
    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div>特高风险提示</div>
              <div></div>
            </div>
          </NavigatorMain>
          <div className='content paddB40'>
            <div className='HighestRisk_header'>
              该产品属于高风险产品，私募股权投资基金具有比较高的风险，其信息披露的频率较低，波动率高。
            </div>
            <div className ='riskQuestionTitleView'>
              <p>按照《证券期货投资者适当性管理办法》规定，投资特高风险产品需要回答如下问题：</p>
            </div>
            {
              this.addQuestions(questionsArr)
            }
          </div>
          <div className='bottomView' >
            <div className='bottomLeftTouchView' onClick = {hashHistory.goBack} >
              <div className='bottomLeftView'>
                <p >取消</p>
              </div>
            </div>
            <div className='bottomRightTouchView' onClick = {()=>{this.goOn()}} >
              <div className='bottomRightView'>
                <p >确定并进入下一步</p>
              </div>
            </div>
          </div>
        </div>
    );
  }
}
class Question extends Component{
  constructor(props){
    super(props);
    this.state = {
      // yesOrNo : null
    };
    this.selectionsArray = [];
  }

  selectionAction(key){
    this.selectionsArray.forEach((item, index, array)=>{
      if(key == index){
        item.setState({
          isSelected: true
        })  
      }else{
        item.setState({
          isSelected: false
        })
      }
    });
    this.props.makeAnswers(this.props.index, key);
  }

  addSelection(selections){
    return selections.map((item, index, array)=>{
      return(
        <Selection option = {item} callback = {(key)=>{this.selectionAction(key)}} ref = {(selection)=>{this.selectionsArray[index] = selection}} key = {index} index = {index}/>
      )
    });
  }

  render(){

    return (
      <div className='questionView'>
        <p  >
          {(Number(this.props.index) + 1) + '、' + this.props.question.title}
        </p>
        {
          this.addSelection(this.props.question.selections)
        }
      </div>
    );
  }
}
class Selection extends Component{
  constructor(props){
    super(props);
    this.state = {
      isSelected: false
    }
  }

  render(){
    return(
      <div  className='questionnaireContent' onClick={()=>{this.props.callback(this.props.index)}}>
          { 
            this.state.isSelected ?
            <img src={require('../../img/circleHookO.png')} />:
            <img src={require('../../img/circleHookG.png')} />
          }
          <div >{this.props.option}</div>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    
  }
}
export default connect(mapStateToProps)(HighestRiskPoint);



// WEBPACK FOOTER //
// ./src/components/pubQuestion/HighestRiskPoint.js